import { SCHEMA_NAMES, type SchemaNames } from "instantdb/types";

export type ResourceCardConfig = {
  titleKey: string;
  descriptionKey: string;
};

export const resourceCardConfig: Record<SchemaNames, ResourceCardConfig> = {
  [SCHEMA_NAMES.healthAreas]: {
    titleKey: "new_resource.health_area.title",
    descriptionKey: "new_resource.health_area.description",
  },
  [SCHEMA_NAMES.goals]: {
    titleKey: "new_resource.goal.title",
    descriptionKey: "new_resource.goal.description",
  },
  [SCHEMA_NAMES.routines]: {
    titleKey: "new_resource.routine.title",
    descriptionKey: "new_resource.routine.description",
  },
};
